module.exports = __webpack_public_path__ + "static/img/logo311_w1.139fc78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo311_w1.png
// module id = wP3W
// module chunks = 47